import React, { forwardRef } from 'react';

import FormItem from './formItem';
import FormItemExtra from './formItemExtra';

import type { IFormItemWrapperProps } from './types';

const FormItemWrapper = forwardRef<HTMLDivElement, IFormItemWrapperProps>(
  (props, ref) => {
    const {
      formik,
      formItem,
      type,
      requiredSymptomFields,
      isShowExtraFields = true,
      isShowExtraExtraFields = true,
      patientGuid,
    } = props;

    const isReadingEscalated = 'isReadingEscalated';
    const escalatedVia = 'escalatedVia';
    const escalatedReasons = 'escalatedReasons';
    const notEscalatedReasons = 'notEscalatedReasons';

    return (
      <FormItem
        formik={formik}
        formItem={formItem}
        modalType={type}
        requiredSymptomFields={requiredSymptomFields ?? []}
        ref={ref}
      >
        {formItem.extra &&
          isShowExtraFields &&
          formItem.extra
            .filter((extra) => {
              if (formItem.name === isReadingEscalated) {
                const value = formik.getFieldMeta(isReadingEscalated)?.value;
                if (value === 'true') {
                  return (
                    extra.name === escalatedVia ||
                    extra.name === escalatedReasons
                  );
                }
                if (value === 'false') {
                  return extra.name === notEscalatedReasons;
                }
                return false;
              }
              return true;
            })
            .map((extra) => {
              const hasExtraExtra =
                isShowExtraExtraFields && Array.isArray(extra.extra);

              return (
                <FormItemExtra
                  key={`extra-${extra.name}`}
                  formik={formik}
                  type={extra.type}
                  name={extra.name}
                  options={extra.options}
                  label={extra.label}
                  divider={extra?.divider}
                  link={extra?.link}
                  formItemName={formItem.name}
                  patientGuid={patientGuid}
                >
                  {hasExtraExtra &&
                    extra.extra?.map((extraExtra) => {
                      return (
                        <FormItemExtra
                          key={`extra-extra-${extraExtra.name}`}
                          formik={formik}
                          type={extraExtra.type}
                          name={extraExtra.name}
                          options={extraExtra.options}
                          label={extraExtra.label}
                          link={extraExtra?.link}
                          subLabel={extraExtra.subLabel}
                          divider={extraExtra?.divider}
                          formItemName={extra.name}
                          patientGuid={patientGuid}
                        />
                      );
                    })}
                </FormItemExtra>
              );
            })}
      </FormItem>
    );
  },
);

export default FormItemWrapper;
